import {
	defaultSalesDetailDto,
	SalesDetailDto,
} from "src/dtos/sales/salesBillDto";

/**
 * SAL2040_R01 - 영업 매출 내역 조회 DTO
 * 매출 헤더와 상세를 조인한 결과
 */
export interface SAL2040_R01Dto extends SalesDetailDto {
	salesBillNo: string;		// 매출번호
	unitNm: string;			// 단위명
}

/**
 * 기본 데이터 (신규 행 추가시 사용)
 */
export const defaultSAL2040_R01Dto: SAL2040_R01Dto = {
	...defaultSalesDetailDto,
	salesBillNo: '',
	unitNm: '',
};
